/** is used by Java BE for audit information (createdBy, createdByMitarbeiterId) + sometimes for permission checks */
export const HEADER_EASYPRO_WEB_FIRMENDATEN_ID = 'easyproweb_firmendaten_id';

/** is used only by GQL BE for adding firmendatenId to uri to avoid needing to send it almost every time to GQL query as variable */
export const HEADER_EASYPRO_WEB_ACTIVE_FOR_FIRMENDATEN_ID = 'easyproweb_active_for_firmendaten_id';
